module.exports = __webpack_public_path__ + "img/hongkong_000.e3dd7c18.png";